var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoBagClickAndCollect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 27.6 32",
    style: {
      enableBackground: "new 0 0 27.6 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#3D2514;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.4,11.8c0.1-1.6-1.1-3-2.6-3.3L9.2,5.8C7.7,5.5,6.1,6.5,5.6,8L0.4,24c-0.6,1.8,0.6,3.8,2.5,4.1l3.5,0.6 c0,0,0-0.1,0.1-0.1l1-1.4c0.3-0.4,0.2-0.9-0.2-1.2l-1-0.7C5.6,25,5.6,24.3,6.2,24l5.9-3.1c0.6-0.3,1.3,0.2,1.2,0.8l-0.8,6.6 c-0.1,0.6-0.8,0.9-1.3,0.6l-1-0.7C9.8,27.9,9.2,28,9,28.4l-0.5,0.8L23,31.7c1.9,0.3,3.7-1.1,3.7-3L27.4,11.8z M14.4,9.9 c-0.1,0.4-0.4,0.6-0.8,0.5c-0.4-0.1-0.6-0.4-0.5-0.8c0.1-0.4,0.4-0.6,0.8-0.5C14.2,9.2,14.5,9.6,14.4,9.9z M19.8,10.9 c-0.1,0.4-0.4,0.6-0.8,0.5c-0.4-0.1-0.6-0.4-0.5-0.8c0.1-0.4,0.4-0.6,0.8-0.5C19.6,10.2,19.8,10.5,19.8,10.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.6,7L19,6.7l0.3-1.7c0.3-1.5-0.5-3-1.7-3.2C17,1.8,16.4,2,15.9,2.4c-0.5,0.5-0.9,1.1-1.1,1.9l-0.3,1.7 L13,5.6L13.3,4c0.2-1.1,0.8-2.2,1.6-2.9c0.9-0.7,1.9-1,3-0.8c2.1,0.4,3.5,2.6,3,5.1L20.6,7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoBagClickAndCollect);
export default __webpack_public_path__ + "static/media/ico-bag-clickAndCollect.34cb427c017a69507dd6a9a31c4d29aa.svg";
export { ForwardRef as ReactComponent };